import cssRuleSetToString from "radium/lib/css-rule-set-to-string"
import hash from "radium/lib/hash"
import { getPrefixedKeyframes } from "radium/lib/prefixer"
import vhpxPlugin from "./vh-px-plugin.js"


const keyframes = (keyframeRules,name) => {
  return {
    __radiumKeyframes: true,
    __process(userAgent) {
      const keyframesPrefixed = getPrefixedKeyframes(userAgent)
      const rules = Object.keys(keyframeRules)
        .map((percentage) => {
          const newKeyframeRules = vhpxPlugin({
            style: keyframeRules[percentage]
          })
          return cssRuleSetToString(percentage, newKeyframeRules.style, userAgent)
        })
        .join("\n")
      const animationName = `${name ? `${name}-` : ""}radium-animation-${hash(rules)}`
      const css = `@${keyframesPrefixed} ${animationName} {\n${rules}\n}\n`
      return { css, animationName }
    }
  }
}


export default keyframes



// WEBPACK FOOTER //
// ./src/higher-order-components/configured-radium/keyframes.js